var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value !== null)?_c('div',[_c('img',{staticClass:"w-16 h-16 object-contain",attrs:{"src":_vm.value,"alt":"Image"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }